// The focus idiom for every interactive element in the bug reporter.
//
// This directory is SHARED CODE — the canonical copy, mirrored into
// palate-customer-app and (eventually) palate-admin-frontend, which do not have
// identical design tokens. So the treatment deliberately uses Tailwind's stock
// palette rather than a semantic token like `ring-ring` or `ring-primary`: a
// token that is not defined in a consuming app degrades to no visible ring at
// all, which is worse than the browser default it replaced (ops-panel#74, DoD
// bullet 2 — "a neutral focus-visible treatment that inherits from the host is
// preferable to hard-coding one app's ring colour").
//
// `slate-400` is readable against both a white surface and the `slate-900`
// active chip in ReporterModal, which is why it is a constant here and not a
// per-call choice. Changing it changes every consumer at once — that is the
// point of the constant.
export const FOCUS_RING =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2'
